export default "__VITE_ASSET__pPLZ69Ns__"